// main.ts
import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhTw from 'element-plus/es/locale/lang/zh-tw';
import '@/styles/style.scss';
import router from './router/routes';
import { setupPinia } from './stores';
import { useThemeStore } from '@/stores/themeStore';
import { useUserStore } from '@/stores/userStore';
import { debounce } from "lodash";

const app = createApp(App);
setupPinia(app);
useThemeStore();
useUserStore().fetchPermissions();

const resizeObserver  = (window).ResizeObserver;
(window).ResizeObserver = class ResizeObserver extends resizeObserver  {
  constructor(callback) {
    callback = debounce(callback, 100);
    super(callback);
  }
};

app.use(router);
app.use(ElementPlus, { locale: zhTw, size: 'large' });
app.mount('#app');
